module.exports = "/cyber/_next/static/images/participation-rules-bg-tablet-c7fc7f0f12a1e062ae1d7a53d3b0a84c.jpg";